<template>
    <intersect rootMargin="-70px 0px 0px 0px" :threshold="[0]" @change="updateFixedStatus">
        <div>
            <main-container ref="header">
                <convention-admin-tools
                    v-if="!displayPrintFormat"
                    :user="user"
                    :convention="convention"
                />
                <convention-tools
                    :user="user"
                    :parentConvention="parentConvention"
                    :displayPrintFormat="displayPrintFormat"
                />
                <convention-teaser
                    :user="user"
                    :parentConvention="parentConvention"
                    :selectedConvention="convention"
                />
            </main-container>
            <div class="small-teaser" v-if="sticky">
                <main-container>
                    <convention-teaser-small :convention="convention" />
                </main-container>
            </div>
        </div>
    </intersect>
</template>

<script>
import ConventionTools from "./ConventionTools.vue";
import Intersect from "vue-intersect";
import ConventionTeaserSmall from "./teaser/ConventionTeaserSmall.vue";
import ConventionTeaser from "./teaser/ConventionTeaser.vue";
import ConventionAdminTools from "./ConventionAdminTools.vue";

export default {
    components: {
        ConventionTeaser,
        ConventionTeaserSmall,
        Intersect,
        ConventionTools,
        ConventionAdminTools,
    },
    props: ["convention", "user", "displayPrintFormat"],
    data() {
        return {
            sticky: false,
        };
    },
    methods: {
        updateFixedStatus(entries) {
            this.sticky = !entries[0].isIntersecting;
        },
    },
    computed: {
        parentConvention() {
            return this.convention.parentConvention
                ? this.convention.parentConvention
                : this.convention;
        },
    },
};
</script>

<style scoped lang="sass">
.small-teaser
    position: fixed
    width: 100%
    top: 60px
    left: 0px
    z-index: 9
    // animation: appear .50s ease-out
    background: $color-secondary

@keyframes appear
    0%
        opacity: 0
    100%
        opacity: 1

@media print
    .small-teaser
        display: none
</style>
